// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3o5PH","description":"PatientConsentPreview_description__3L4nH"};